/** Primetime Emmy TV nominations by year → category → [{ id, won }].
 *  Mirrors goldenGlobeTvNominations so Emmy rails render with the same
 *  winner-first, newest-year-first ordering. Add prior years here as data
 *  becomes available. 2026 series winners verified against the Television Academy. */

export default {
  "2026": {
    drama: [
      { id: 203857, won: false },
      { id: 81723, won: false },
      { id: 224372, won: false },
      { id: 245927, won: false },
      { id: 250307, won: true },
      { id: 225171, won: false },
      { id: 95480, won: false },
      { id: 241609, won: false },
    ],
    comedy: [
      { id: 125935, won: false },
      { id: 136315, won: false },
      { id: 124101, won: false },
      { id: 245318, won: false },
      { id: 250923, won: false },
      { id: 107113, won: false },
      { id: 136311, won: false },
      { id: 270476, won: true },
    ],
    limited: [
      { id: 246386, won: false },
      { id: 250504, won: false },
      { id: 154385, won: false },
      { id: 206828, won: true },
      { id: 131142, won: false },
    ],
    reality: [
      { id: 1508, won: false },
      { id: 8514, won: false },
      { id: 14658, won: false },
      { id: 41822, won: false },
      { id: 215943, won: true },
    ],
    animated: [
      { id: 60625, won: false },
      { id: 126506, won: false },
      { id: 2190, won: true },
      { id: 114478, won: false },
      { id: 456, won: false },
    ],
    variety: [
      { id: 2224, won: false },
      { id: 1489, won: false },
      { id: 60694, won: false },
      { id: 63770, won: true },
      { id: 1667, won: false },
    ],
  },
};
